export const listItemSx = {
  height: '20%',
  textAlign: 'center',
};

export const listItemTextSx = ({ theme, sx }) => ({
  sx: {
    color: theme.palette.secondary.main,
    ...sx,
    display: 'inline-block',
    '&:after': {
      display: 'block',
      content: '""',
      borderBottom: `solid 3px ${theme.palette.tertiary.main}`,
      transform: 'scaleX(0)',
      transition: 'transform 400ms ease-in-out',
    },
    '&:hover:after': { transform: 'scaleX(1)', transformOrigin: '0% 50%' },
  },
});
